var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('RelatorioPaisagem',[_c('b-table',{staticStyle:{"text-align":"start"},attrs:{"striped":"","small":"","id":"table_export_id","head-variant":'light',"items":_vm.parametro.dados,"fields":_vm.parametro.colunas}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }